import {RequestActionTypes} from "../create_request_action_types";
import {PaginatedResponseAction} from "../../interfaces/dispatch";


export function reducePaginatedResponseWithReset<T>(requestTypes: RequestActionTypes) {
    return (state: T[] = [], action: PaginatedResponseAction<T>): T[] => {
        switch (action.type) {
            case requestTypes.success:
                return action.results;
            case requestTypes.reset:
                return [];
            default:
                return state;
        }
    };
}
